import Inputmask from "inputmask";

export class SelectCountryPhone {
    constructor(optionalOptions = {}) {
        this._countryList = document.querySelector('.sheet-column .select-country-phone');

        if (!this._countryList) {
            this.destructor();
            return true;
        }

        this._countryOne = this._countryList.querySelectorAll('li')
        if (!this._countryOne) {
            this.destructor();
            return true;
        }

        let buttonMask
        let selectWrapText
        let phoneElement = document.querySelector('[name="phone"]')

        if (phoneElement) {
            let closestDiv = phoneElement.closest('.base-input-select--wrp');
            if (closestDiv) {
                selectWrapText = closest.querySelector('.base-input-select--data .base-input-select--choose')
            }
        }

        let thatCountryList = this._countryList

        const removeSelectedMarker = (thatCountryList) => {
            thatCountryList.querySelector('.sheet-column .select-country-phone li.selected').classList.remove('selected');
        }

        this._countryOne.forEach((one) => {
            one.addEventListener("click", () => {
                buttonMask = one.dataset.mask

                if (!buttonMask) {
                    return false
                }

                if (one.classList.contains('selected')) {
                    return false
                }

                removeSelectedMarker(thatCountryList)

                one.classList.add('selected')

                if (phoneElement) {
                    phoneElement.value = ""

                    Inputmask({
                        "clearMaskOnLostFocus": true,
                        "clearIncomplete": true,
                        "mask": buttonMask
                    }).mask(phoneElement);

                    if (selectWrapText) {
                        selectWrapText.innerHTML = one.innerHTML
                    }
                }

                document.querySelector('.sheet-overlay').click()
            })
        })
    }

    destructor() {
        this._countryList = null;
        this._countryOne = null;
    }
}

export default new SelectCountryPhone();
